document.querySelectorAll('[data-carousel-track]').forEach((track) => {
  const wrapper = track.parentElement;
  const prevBtn = wrapper ? wrapper.querySelector('[data-carousel-prev]') : null;
  const nextBtn = wrapper ? wrapper.querySelector('[data-carousel-next]') : null;
  const scrollAmount = 360;

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  }
});

document.querySelectorAll('.product-carousel__track').forEach((track) => {
  track.addEventListener('click', (event) => {
    const swatchBtn = event.target.closest('.product-carousel__swatch-btn');
    if (!swatchBtn) return;

    const item = swatchBtn.closest('.product-carousel__item');
    const mainImg = item.querySelector('.product-carousel__image--main');
    if (mainImg && swatchBtn.dataset.image) {
      mainImg.src = swatchBtn.dataset.image;
    }
  });
});

if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  document.querySelectorAll('[data-holo-card]').forEach((card) => {
    card.addEventListener('pointermove', (event) => {
      if (event.pointerType === 'touch') return;
      const rect = card.getBoundingClientRect();
      const x = ((event.clientX - rect.left) / rect.width) * 100;
      const y = ((event.clientY - rect.top) / rect.height) * 100;
      card.style.setProperty('--mx', `${x}%`);
      card.style.setProperty('--my', `${y}%`);
      const rotateY = ((x - 50) / 50) * 6;
      const rotateX = ((50 - y) / 50) * 6;
      card.style.transform = `translateY(-4px) perspective(800px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
    });

    card.addEventListener('pointerleave', () => {
      card.style.setProperty('--mx', '50%');
      card.style.setProperty('--my', '50%');
      card.style.transform = '';
    });
  });
}
